import PropTypes from 'prop-types';
import React from 'react';
import { isIOS, isAndroid, isMobileOnly } from 'react-device-detect';
import config from '../../../config';
import { openLocationWithPrefix } from '../../utils/routes';

const DeepLinkRedirect = ({
  confirmationCode,
  extension,
  customer,
  send,
  smsSent,
  brandRoute,
  reservation,
}) => {
  const androidUrl = extension && extension.playStoreLink
    ? `${extension.playStoreLink}&referrer=confirmationCode%3D${confirmationCode}`
    : `${config.flagshipAppUrls.android}&referrer=confirmationCode%3D${confirmationCode}`;
  const iosUrl = extension && extension.iTunesLink
    ? extension.iTunesLink
    : config.flagshipAppUrls.ios;
  let shouldRedirect = false;

  if (isAndroid && androidUrl) {
    window.location.assign(androidUrl);
    shouldRedirect = true;
  } else if (isIOS && iosUrl) {
    window.location.assign(iosUrl);
    shouldRedirect = true;
  } else if (!isMobileOnly) {
    openLocationWithPrefix(`/view-reservation/${reservation.appointment.id}`);
    shouldRedirect = true;
  }

  if ((brandRoute && !extension) || shouldRedirect) {
    return (<div className="o-wrapper u-text-center alpha u-mt">Loading...</div>);
  }

  const copy = smsSent ? 'SMS Sent' : `Text me the link to phone ending in ${customer.phone.slice(-4)}`;
  return (
    <div className="o-wrapper u-text-center alpha u-mt">
      Download the {brandRoute ? extension.name : 'Squire'} app to manage your appointments.
      <br />
      <br />
      <button
        className="c-btn c-btn--secondary u-1/1"
        onClick={send}
        disabled={smsSent}
      >
        {copy}
      </button>
    </div>
  );
};

DeepLinkRedirect.propTypes = {
  confirmationCode: PropTypes.string.isRequired,
  extension: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  customer: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  send: PropTypes.func.isRequired,
  smsSent: PropTypes.bool.isRequired,
  brandRoute: PropTypes.string,
  reservation: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};
DeepLinkRedirect.defaultProps = {
  brandRoute: '',
  extension: null,
};

export default DeepLinkRedirect;




// WEBPACK FOOTER //
// ./src/app/mobileApp/components/DeepLinkRedirect.jsx